import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaEnvelope, FaBox, FaUserCheck, FaTruck } from 'react-icons/fa';

const NEXT_STEPS = [
  {
    icon: <FaEnvelope className="text-[#c78244]" />,
    title: 'Controlla la tua email',
    desc: 'Tutti i referenti ricevono un codice di accesso personale per modificare la candidatura in qualsiasi momento.',
  },
  {
    icon: <FaBox className="text-[#c78244]" />,
    title: 'Valutazione del team',
    desc: 'Quando invii la candidatura completa, l\'amministrazione la revisiona. Le bozze non entrano in valutazione.',
  },
  {
    icon: <FaUserCheck className="text-[#c78244]" />,
    title: 'Campione e accreditamento',
    desc: 'Se approvata, spedisci un campione imballato come per un cliente. Dopo la verifica ricevi credenziali e kit di avvio.',
  },
  {
    icon: <FaTruck className="text-[#c78244]" />,
    title: 'Vai online',
    desc: 'Gestisci prodotti, disponibilità e ordini dall\'area riservata fornitore su mangitalia.online/fornitore.',
  },
];

export default function CandidaturaSuccess({ type = 'submit', codiceAccesso = '', emailNotifica = null, onContinueDraft }) {
  const isBozza = type === 'bozza';
  const destinatari = emailNotifica?.destinatari ?? [];
  const emailInviata = emailNotifica?.inviata === true;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full max-w-2xl mx-auto px-4 py-10"
      data-tour="candidatura-success"
    >
      <div className="text-center mb-8">
        <div className="text-6xl mb-4">{isBozza ? '💾' : '🎉'}</div>
        <h2 className="text-2xl sm:text-3xl font-bold text-[#c78244] mb-2">
          {isBozza ? 'Bozza salvata!' : 'Candidatura inviata!'}
        </h2>
        <p className="text-gray-600">
          {isBozza
            ? 'I tuoi dati sono al sicuro. Completa e invia quando sei pronto — fino ad allora non entra in valutazione.'
            : 'La tua candidatura è in coda per la revisione del team Mangitalia.'}
        </p>
        {codiceAccesso && (
          <div className="mt-4 inline-block bg-[#fff8ea] border border-[#f3deb8] rounded-xl px-5 py-3">
            <p className="text-xs uppercase tracking-widest text-[#9a5f2f] mb-1">Il tuo codice accesso</p>
            <p className="text-xl font-mono font-bold text-[#c78244]">{codiceAccesso}</p>
          </div>
        )}
        {destinatari.length > 0 && (
          <p className="mt-4 text-sm text-gray-600">
            {emailInviata ? (
              <>Email inviata a: <strong>{destinatari.join(', ')}</strong>. Controlla anche la cartella spam.</>
            ) : (
              <>Impossibile inviare l&apos;email a {destinatari.join(', ')}. Scrivi a{' '}
                <a href="mailto:candidatura@mangitalia.online" className="text-[#c78244] underline">
                  candidatura@mangitalia.online
                </a>{' '}
                con il codice <strong>{codiceAccesso}</strong>.</>
            )}
          </p>
        )}
        {!emailInviata && destinatari.length === 0 && emailNotifica?.errore && (
          <p className="mt-4 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
            Email non inviata: {emailNotifica.errore}. Annota il codice <strong>{codiceAccesso}</strong> oppure scrivi a candidatura@mangitalia.online.
          </p>
        )}
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-6 space-y-5">
        <h3 className="font-bold text-lg text-gray-800">Cosa succede adesso</h3>
        {NEXT_STEPS.map((item, i) => (
          <div key={item.title} className="flex gap-4">
            <div className="w-10 h-10 rounded-full bg-[#fff8ea] flex items-center justify-center shrink-0 text-lg">
              {item.icon}
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-0.5">Step {i + 1}</p>
              <p className="font-semibold text-gray-800">{item.title}</p>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap justify-center gap-3 mt-8">
        {!isBozza && (
          <Link
            to="/diventa-partner"
            className="border border-[#c78244] text-[#c78244] px-6 py-3 rounded-full font-semibold"
          >
            Torna all&apos;hub partner
          </Link>
        )}
        {isBozza && (
          <button
            type="button"
            onClick={onContinueDraft}
            className="bg-[#c78244] text-white px-6 py-3 rounded-full font-semibold"
          >
            Continua a compilare
          </button>
        )}
        <Link to="/catalogo" className="text-sm text-gray-500 underline self-center">
          Esplora il catalogo
        </Link>
      </div>
    </motion.div>
  );
}
